/**
 * Screens, routes and buttons ask for "View X" / "Manage X" keys from the PermissionModules enum below.
 * The server decides what a user can do: GET /users/get_self returns { module_key: 'none' | 'view' | 'manage' }.
 * Each key is translated to a server { module, level } in permission-map.ts.
 * When you add a new key here, add it to PERMISSION_KEY_MAP too - permission-map.spec.ts fails otherwise.
 */

export enum Modules {
  MANAGE_PEOPLE = 'Manage People',
  PROJECT_STAFFING = 'Project Staffing and Estimating',
  MANAGE_CLIENT = 'Manage Clients',
  MANAGE_PROJECT = 'Manage Projects',
  UTILIZATION_MANAGEMENT = 'Utilization Management',
  BENCH_REPORT = 'Bench Report',
  STAFF_POSITION_REPORT = 'Positions Report',
  BILL_RATE = 'Financial Data',
  BILL_RATE_OPEN_POS = 'Financial Data',
  OPEN_POSITION_PERMISSIONS = 'Lost Revenue Permissions',
  OPEN_POSITION_REPORT = 'Lost Revenue',
  FINANCIAL_FORECASTING = 'Financial Forecasting',
  ACCESS_CONTROL = 'Access Control',
  MANAGE_USER = 'Manage Users',
  CREATE_USER = 'Create User',
  MANAGE_PL = 'Manage P&L',
  COMPARE_PL = 'P&L Comparison',
  ADMINISTRATION = 'Administration',
  MANAGE_EMPLOYEE = 'Manage Employee',
  MANAGE_WORK_EXCEPTION = 'Manage Work Exceptions',
  MANAGE_ROLE = 'Manage Role',
  MANAGE_EXPENSE_TYPE = 'Manage Expense Type',
  MANAGE_EMPLOYEE_TYPE = 'Manage Employee Type',
  MANAGE_POSITION_TYPE = 'Manage Position Type',
  MANAGE_ExtendedFiled = 'Manage Extended Filed',
  MANAGE_MONTHLY_EXPENSE_TYPE = 'Manage Monthly Expense Type',
  MANAGE_PROJECT_STATUS = 'Manage Project Status',
  MANAGE_HOLIDAY = 'Manage Holidays',
  MANAGE_WORK_EXCEPTION_TYPE = 'Manage Work Exception Type',
  MANAGE_FIXED_BID_LOCK = 'Manage Fixed Bid Locks',
  GENERAL_PERMISSIONS = 'General',
  SHARE_FILTERS = 'Share Filter',
  PROJECT_PERMISSIONS = 'Project Permissions',
  STAFFED_POSITION_PERMISSIONS = 'Positions Report Permissions',
  MANAGE_TAG_CATEGORY = 'Manage Tag Category',
  MANAGE_TAG_SUB_CATEGORY = 'Manage Tag Sub Category',
  MANAGE_TAG = 'Manage Tag',
  IMPORT_ACTUALS = 'Import Actuals',
  MANAGE_TIME = 'Manage Time',
  Create_TIME = 'Create Time',
  Work_Exception_Request = 'Work Exception Request',
  PL_PLUGS = 'P&L Plugs',
  NET_MARGIN = 'Net Margin'
}

export enum Permissions {
  NO_ACCESS = 'No Access ',
  CAN_VIEW = 'View ',
  CAN_MANAGE = 'Manage '
}

export enum ModuleNames {
  CLIENT = 'Client',
  PROJECT = 'Project',
  PL = 'P&L',
  COMPARE_PL = 'P&L Comparison',
  EMPLOYEE = 'Employee',
  WORK_EXCEPTION = 'Work Exceptions',
  IMPORT_ACTUALS = 'Import Actuals',
  ROLE = 'Role',
  EXPENSE_TYPE = 'Expense Type',
  EMPLOYEE_TYPE = 'Employee Type',
  POSITION_TYPE = 'Position Type',
  ExtendedFiled = 'Extended Filed',
  MONTHLY_EXPENSE_TYPE = 'Monthly Expense Type',
  HOLIDAY = 'Holidays',
  WORK_EXCEPTION_TYPE = 'Work Exception Type',
  FIXED_BID_LOCK = 'Fixed Bid Lock',
  SHARE_FILTER = 'Share Filter',
  PROJECT_STATUS = 'Project Status',
  MANAGE_USER = 'Manage User',
  CREATE_USER = 'Create User',
  BILL_RATE_OPEN_POS = 'Financial Data Open Position',
  MANAGE_TAG_CATEGORY = 'Manage Tag Category',
  MANAGE_TAG_SUB_CATEGORY = 'Manage Tag Sub Category',
  MANAGE_TAG = 'Manage Tag',
  MANAGE_TIME_ENTRIES = 'Manage Time Entries',
  TIME_ENTRIES = 'Time Entries',
  Create_ENTRIES = 'Create Entries',
  Work_Exception_Request = 'Work_Exception_Request',
  PL_PLUGS = 'P&L Plugs',
  NET_MARGIN = 'Net Margin'
}

export enum PermissionModules {
  VIEW_CLIENT = 'View Client',
  MANAGE_CLIENT = 'Manage Client',
  VIEW_PROJECT = 'View Project',
  MANAGE_PROJECT = 'Manage Project',
  VIEW_PL = 'View P&L',
  MANAGE_PL = 'Manage P&L',
  VIEW_COMPARE_PL = 'View P&L Comparison',
  MANAGE_COMPARE_PL = 'Manage P&L Comparison',
  VIEW_BENCH_REPORT = 'View Bench Report',
  MANAGE_BENCH_REPORT = 'Manage Bench Report',
  VIEW_OPEN_POSITION_REPORT = 'View Lost Revenue',
  MANAGE_OPEN_POSITION_REPORT = 'Manage Lost Revenue',
  VIEW_STAFFED_POSITION_REPORT = 'View Positions Report',
  MANAGE_STAFFED_POSITION_REPORT = 'Manage Positions Report',
  VIEW_BILL_RATE = 'View Financial Data',
  VIEW_BILL_RATE_OPEN_POS = 'View Financial Data Open Position',
  VIEW_EMPLOYEE = 'View Employee',
  MANAGE_EMPLOYEE = 'Manage Employee',
  VIEW_WORK_EXCEPTION = 'View Work Exceptions',
  MANAGE_WORK_EXCEPTION = 'Manage Work Exceptions',
  VIEW_IMPORT_ACTUALS = 'View Import Actuals',
  MANAGE_IMPORT_ACTUALS = 'Manage Import Actuals',
  VIEW_ROLE = 'View Role',
  MANAGE_ROLE = 'Manage Role',
  VIEW_EXPENSE_TYPE = 'View Expense Type',
  MANAGE_EXPENSE_TYPE = 'Manage Expense Type',
  VIEW_EMPLOYEE_TYPE = 'View Employee Type',
  MANAGE_EMPLOYEE_TYPE = 'Manage Employee Type',
  VIEW_POSITION_TYPE = 'View Position Type',
  MANAGE_POSITION_TYPE = 'Manage Position Type',
  VIEW_MONTHLY_EXPENSE_TYPE = 'View Monthly Expense Type',
  MANAGE_MONTHLY_EXPENSE_TYPE = 'Manage Monthly Expense Type',
  MANAGE_PROJECT_STATUS = 'Manage Project Status',
  VIEW_HOLIDAY = 'View Holidays',
  MANAGE_HOLIDAY = 'Manage Holidays',
  VIEW_WORK_EXCEPTION_TYPE = 'View Work Exception Type',
  MANAGE_WORK_EXCEPTION_TYPE = 'Manage Work Exception Type',
  MANAGE_FIXED_BID_LOCK = 'Manage Fixed Bid Lock',
  VIEW_FIXED_BID_LOCK = 'View Fixed Bid Lock',
  VIEW_SHARE_FILTER = 'View Share Filter',
  MANAGE_SHARE_FILTER = 'Manage Share Filter',
  VIEW_MANAGE_USER = 'View Manage User',
  CREATE_USER = 'Create User',
  MANAGE_USER = 'Manage User',
  VIEW_MANAGE_TAG_CATEGORY = 'View Manage Tag Category',
  CREATE_TAG_CATEGORY = 'Create Tag Category',
  MANAGE_TAG_CATEGORY = 'Manage Manage Tag Category',
  VIEW_MANAGE_TAG_SUB_CATEGORY = 'View Manage Tag Sub Category',
  CREATE_TAG_SUB_CATEGORY = 'Create Tag Sub Category',
  MANAGE_TAG_SUB_CATEGORY = 'Manage Tag Sub Category',
  VIEW_MANAGE_TAG = 'View Manage Tag',
  CREATE_TAG = 'Create Tag',
  MANAGE_TAG = 'Manage Tag',
  VIEW_TIME_ENTRIES = 'View Time Entries',
  Create_TIME_ENTRIES = 'Manage Create Entries',
  MANAGE_TIME_ENTRIES = 'Manage Time Entries',
  View_Create_Entries = 'View Create Entries',
  MANAGE_Extended_Filed = 'Manage Extended Filed',
  View_Extended_Filed = 'View Extended Filed',
  View_Work_Exception_Request = 'View Work_Exception_Request',
  Manage_Work_Exception_Request = 'Manage Work_Exception_Request',
  MANAGE_PL_PLUGS = 'Manage P&L Plugs',
  VIEW_PL_PLUGS = 'View P&L Plugs',
  VIEW_NET_MARGIN = 'View Net Margin'
}

const redirectValue = {
  [PermissionModules.VIEW_CLIENT]: ''
};

export enum AdminOnlyPermission {
  MANAGE_GLOBAL_DETAIL = 'Manage Global Detail'
}
